import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../../config/api";
import { BASE_API } from "../../../../constants/apiUrls";
import { toast } from "../../../../lib/toast";
import {
  CommonOthers,
  ErrorMessage,
  GetCommonData,
  GetSingleDataParams,
  Params,
  PostRequest,
} from "../../../../types";
import {
  createRegionalHub,
  regionHubData,
  regionHubDataParams,
} from "../../../../types/geo/regionalHub";
import { handleApiError } from "../../../../utils/errorHandler";

// create
export const createRegionalHubAsync = createAsyncThunk<
  null,
  PostRequest<createRegionalHub, CommonOthers>
>(
  "admin/createRegionalHub",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.post(BASE_API.createRegionalHub, data);

      reRender(true);
      toast("success", "create successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "create fail");
      return rejectWithValue(error);
    }
  }
);

// get all region hub
export const getAllRegionalHubAsync = createAsyncThunk<
  GetCommonData<regionHubData>,
  Params<regionHubDataParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllRegionalHub", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as regionHubDataParams;

  try {
    const data = await AXIOS.get(BASE_API.getRegionalHub, {
      params: { ...rest },
      headers: {},
    });

    return {
      data: data.data?.getData,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get region fail");
    return rejectWithValue(error);
  }
});

// update
export const updateRegionalHubAsync = createAsyncThunk<
  null,
  PostRequest<createRegionalHub, GetSingleDataParams>
>(
  "admin-geo/updateRegionalHub",
  async ({ data, others: { reRender, id } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updateRegionalHub}/${id}`, data);

      reRender && reRender(true);
      toast("success", "update successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "update fail");
      return rejectWithValue(error);
    }
  }
);
